import { OtpCard } from "../components/otp-card";
import { AuthPagesEnum } from "../constants";
import { TrustedBy } from "~/components/chat/ai/ask/ecommerce/components/components/trusted-by";
import { Link } from "~/components/link";
import { useMamaNavigateState } from "~/navigation/use-mama-navigate-state";
import { useTenantConfig } from "~/tenant-settings";

const Logo: React.FC = () => {
  const settings = useTenantConfig();

  return (
    <Link href={AuthPagesEnum.MAGIC_SIGN_IN} className="mb-6 py-2">
      <img
        className="self-center object-contain object-bottom"
        src={settings?.authLogo}
        width={160}
        height={32}
        alt="Mama Health"
        loading="eager"
        decoding="async"
      />
    </Link>
  );
};

export const CognitoMagicLinkSent: React.FC = () => {
  const { email } = useMamaNavigateState();

  return (
    <div className="min-h-dvh flex h-full w-full flex-col items-center bg-green-light-50 p-4">
      <Logo />
      {email ? (
        <div className="mx-4 mb-28 flex w-full max-w-[560px] flex-col items-center gap-y-6 rounded-xl bg-white p-6 text-mama-blue-950 shadow-md">
          <OtpCard mode="signIn" email={email} />
        </div>
      ) : null}
      <TrustedBy />
    </div>
  );
};
